import React from "react";
import {Checkbox, Switch, TextField} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import EntityMixedType from "./EntityMixedType";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const useStyles = makeStyles({
    wrapper: {
        outline: 'none',
        display: 'flex',
        alignItems: 'center'
        //TODO add width
    }
});

const FieldComponent = ({component}) => {
    const {properties, styles} = component;
    const fieldStyles = styles.length ? styles[0] : {};
    const labelStyles = styles.length > 1 ? styles[1] : {};

    function renderByType(type) {
        switch (type) {
            case 'entityMixed':
                return <EntityMixedType
                    properties={properties}
                    labelStyles={labelStyles}
                    fieldStyles={fieldStyles}
                />;
            default:
                return <DefaultFieldType
                    labelStyles={labelStyles}
                    fieldStyles={fieldStyles}
                    properties={properties}
                />
        }
    }

    return (
        properties ? renderByType(properties.type) : <>undefined type</>
    )
};

export default FieldComponent;


const DefaultFieldType = ({fieldStyles, labelStyles, properties}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage)
    const fieldPresentationProps =
        fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
        fieldStyles.presentation === 'stackLabel' ? 'outlined' :
        fieldStyles.presentation;
    const inlineLabel = fieldStyles.presentation ?
        fieldStyles.presentation !== 'standard'
        : true;

    return (
        <div className={classes.wrapper}>
            {inlineLabel && !fieldStyles.hideLabel && (
                <span
                    style={{
                        ...labelStyles,
                        width: labelStyles.width,
                        margin: labelStyles.margin,
                        display: 'inline-block',
                        position: 'relative'
                    }}
                >
                    {multiLanguageLabel}
                </span>
            )}
            {
                fieldStyles.presentation === 'switch' ? (
                        <Switch
                            color={"primary"}
                            size={"small"}
                            disabled={true}
                        />
                    ) :
                    fieldStyles.presentation === 'checkbox' ? (
                            <Checkbox
                                size={"small"}
                                disabled={true}
                            />
                        ) :
                        fieldStyles.presentation === 'radio' ? (
                            <RadioGroup row>
                                <FormControlLabel value="true" control={<Radio size={"small"} color={"primary"}/>}
                                                  label="True" disabled/>
                                <FormControlLabel value="false" control={<Radio size={"small"} color={"primary"}/>}
                                                  label="False" disabled/>
                            </RadioGroup>
                        ) : (
                            <TextField
                                disabled
                                placeholder={fieldStyles.presentation === 'standard' ? multiLanguageLabel : ''}
                                fullWidth={fieldStyles.fullWidth}
                                inputProps={{
                                    style: {
                                        width: fieldStyles.fullWidth ? '100%' : fieldStyles.width,
                                        height: fieldStyles.height
                                    }
                                }}
                                variant={fieldPresentationProps || "outlined"}
                                className={'form-dynamic'}
                            />
                        )
            }

        </div>
    )
};